// UI strings for the Pääteopas cards in Kielioppi § 7 (app/src/grammar/paateopas.tsx), Finnish (default) and English
// side by side. The cards' texts themselves are in app/src/grammar/07-words.mdx, in both languages.
import { defineArea } from '../area';

/** Adjective classes as the grammar writes them (I-luokan adjektiivi). */
const ROMAN: Record<string, string> = { '1': 'I', '2': 'II', '3': 'III' };

export const paateopasFi = {
  /** Under a card's title: the Finnish endings that do the same job ("Suomen vastineet: -la, -mo, -sto"). */
  inFinnish: 'Suomen vastineet:',
  /** Under a rule or another ending: how many of Peterson's words show it for this meaning. */
  peterson: (n: number) => (n === 1 ? 'Petersonilla 1 sana' : `Petersonilla ${n} sanaa`),
  /** A rule whose default is our choice among the suffixes Peterson uses for one meaning (OUR_CHOICE in grammar/paateopas-cards.ts). */
  ourChoice: 'meidän valintamme',
  /** How every one of Peterson's adjectives with the ending inflects (a noun: the gender and the declension). */
  adjClass: (c: string) => `${ROMAN[c] ?? c}-luokan adjektiivi`,
  /** A choice with few examples or a meaning that always shifts (style.json `thin`). */
  thin: 'Varmaa sääntöä ei ole: jokainen uusi sana harkitaan erikseen.',
  /** The reading index above the cards. */
  index: 'Johdin ja sen kortti',
  /** Before an example's derived word, for screen readers ("bardugon → bardulion"). */
  makes: 'josta tulee',
};

export const paateopasEn: typeof paateopasFi = {
  inFinnish: 'In Finnish:',
  peterson: (n) => (n === 1 ? '1 word of Peterson’s' : `${n} words of Peterson’s`),
  ourChoice: 'our choice',
  adjClass: (c) => `class ${ROMAN[c] ?? c} adjective`,
  thin: 'No firm rule: each new word is weighed on its own.',
  index: 'Each suffix and its card',
  makes: 'gives',
};

// Messages.paateopas (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('paateopas', paateopasFi, paateopasEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof paateopasFi> {}
}
